import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Table, UncontrolledTooltip } from 'reactstrap';
import { toast } from 'react-toastify';

import Breadcrumbs from '../../../components/Common/Breadcrumb';
import Pagination from '../../../components/Common/Pagination';
import ConfirmDelete from '../../../components/Common/ConfirmDelete';

import companyService from '../../../services/companyService';
import { formatDate } from '../../../helpers/dateHelper';

function Companies(props) {
  const [companies, setCompanies] = useState([]);
  const [company, setCompany] = useState([]);

  const [query, setQuery] = useState('');
  const [paginationData, setPaginationData] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [confirmDelete, setconfirmDelete] = useState(false);

  async function getCompanies(query, limit, page) {
    try {
      setApiLoading(true);
      const response = (await companyService.getCompanies({ query, limit, page })).data;
      setCompanies(response.companies);
      setPaginationData(response.metaData);
      setApiLoading(false);
    } catch (err) {
      setApiLoading(false);
      toast.error(err.message || 'Error Fetching Startups');
    }
  }
  useEffect(() => {
    getCompanies(query, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePaginationClick = (page) => {
    getCompanies(query, limit, page);
  };

  const handleLimitChange = (event) => {
    const { value } = event.target;
    setLimit(value);
    getCompanies(query, value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    getCompanies(query, limit);
  };

  const handleChange = (event) => {
    setQuery(event.target.value);
  };

  const handleonDelete = (founder) => {
    setCompany(founder);
    setconfirmDelete(true);
  };

  const handleDelete = async (event) => {
    try {
      setApiLoading(true);
      await companyService.deleteCompany(company.id);
      toast.success(`${company.name} deleted successfully`);
      setApiLoading(false);
      getCompanies(query, limit);
    } catch (err) {
      setApiLoading(false);
      toast.error(err.message || 'Error Fetching Founders');
    }
    setconfirmDelete(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs mainSection="Startups" subSection="All Startups" />

          {confirmDelete && (
            <ConfirmDelete
              confirmBtnText={`Delete Company`}
              onConfirm={handleDelete}
              onCancel={() => setconfirmDelete(false)}
              message={`You are about to delete ${company.name}`}
            />
          )}
          <Row>
            <form className="p-3" onSubmit={handleSubmit}>
              <div className="form-group m-0">
                <div className="input-group">
                  <input
                    type="search"
                    value={query}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Search startups ..."
                  />
                  <div className="input-group-append">
                    <button className="btn btn-primary" type="submit">
                      <i className="mdi mdi-magnify"></i>
                    </button>
                  </div>
                  <div className="input-group-append">
                    <label htmlFor="search" className="col-form-label" style={{ margin: '0 5px 0 10px' }}>
                      Limit
                    </label>
                    <select id="search" value={limit} onChange={handleLimitChange} className="form-control">
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </Row>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="mb-2 text-center">
                    {apiLoading && <i className="bx bx-loader bx-spin  bx-sm"></i>}
                  </div>
                  {paginationData?.pageCount > 0 && (
                    <Row>
                      <Col lg="12">
                        <Pagination data={paginationData} onPaginationClick={handlePaginationClick} />
                      </Col>
                    </Row>
                  )}
                  <div className="table-responsive">
                    <Table className="table-centered table-nowrap table-hover">
                      <thead className="thead-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Logo</th>
                          <th scope="col">Name</th>
                          <th scope="col">Location</th>
                          <th scope="col">sector</th>
                          <th scope="col">Date Founded</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {companies?.length > 0 &&
                          companies.map((company) => (
                            <tr key={company.id}>
                              <td>
                                <Link to={`/startups/edit/${company.id}`} id={'company' + company.id}>
                                  <span>{company.id}</span>
                                </Link>
                              </td>
                              <td>
                                <Link to={`/startups/edit/${company.id}`} id={'company' + company.id}>
                                  {!company.logoUrl ? (
                                    <div className="avatar-xs">
                                      <span className="avatar-title rounded-circle">
                                        {company.name.charAt(0).toUpperCase()}
                                      </span>
                                    </div>
                                  ) : (
                                    <div>
                                      <img className="rounded-circle avatar-xs" src={company.logoUrl} alt="" />
                                    </div>
                                  )}
                                </Link>
                              </td>
                              <td>
                                <Link to={`/startups/edit/${company.id}`} id={'company' + company.id}>
                                  <h5 className="font-size-14 mb-1">{company.name}</h5>
                                </Link>
                              </td>
                              <td>
                                <h5 className="font-size-14 mb-1">{company.location}</h5>
                              </td>
                              <td>{company.sector}</td>
                              <td>
                                {company.dateFounded && formatDate(new Date(company.dateFounded), 'MMMM dd, yyyy')}
                              </td>
                              <td>
                                <ul className="list-inline font-size-20 contact-links mb-0">
                                  <li className="list-inline-item px-2">
                                    <Link to={`/startups/edit/${company.id}`} id={'company' + company.id}>
                                      <i className="bx bx-edit"></i>
                                      <UncontrolledTooltip placement="top" target={'company' + company.id}>
                                        Edit
                                      </UncontrolledTooltip>
                                    </Link>
                                  </li>
                                  <li className="list-inline-item px-2">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a onClick={() => handleonDelete(company)}>
                                      <i className="bx bx-trash"></i>
                                    </a>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                        {companies?.length === 0 && !apiLoading && (
                          <tr>
                            <th colSpan="8" className="text-center">
                              no Startups found
                            </th>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  {paginationData?.pageCount > 0 && (
                    <Row>
                      <Col lg="12">
                        <Pagination data={paginationData} onPaginationClick={handlePaginationClick} />
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withRouter(Companies);
